import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { getStatusUpdateSignalMatch } from '@confluence/status-update-signal/entry-points/getStatusUpdateSignalMatch.ts';
import type {
	StatusUpdateChild,
	StatusUpdateSignalMatch,
} from '@confluence/status-update-signal/entry-points/getStatusUpdateSignalMatch.ts';

interface UseMatchesStatusUpdateInput {
	title?: string | null;
	parentTitle?: string | null;
	sourceTemplateEntityId?: string | null;
	children?: readonly StatusUpdateChild[];
}

export const useMatchesStatusUpdate = ({
	title,
	parentTitle,
	sourceTemplateEntityId,
	children,
}: UseMatchesStatusUpdateInput): StatusUpdateSignalMatch => {
	const intl = useIntl();

	return useMemo(
		() =>
			getStatusUpdateSignalMatch(
				{
					title: title ?? undefined,
					parentTitle: parentTitle ?? null,
					templateId: sourceTemplateEntityId ?? null,
					children,
				},
				intl,
			),
		[title, parentTitle, sourceTemplateEntityId, children, intl],
	);
};
